import type { AuthSession, SocialProviderName } from '@repo/api-contracts';
import { env } from '../config/env';

/** 소셜 콜백 code ↔ 세션 교환 응답 봉투(ApiResponse) 중 필요한 부분. */
interface ExchangeEnvelope {
  readonly success: boolean;
  readonly data: AuthSession | null;
  readonly error: { readonly message: string } | null;
}

/** OAuth 시작 주소 — 브라우저 최상위 내비게이션으로 이동해야 한다. (리다이렉트 플로우) */
export const socialSignInUrl = (provider: SocialProviderName): string =>
  `${env.VITE_API_URL}/api/auth/social/${provider}`;

/**
 * 콜백이 발급한 일회용 code 를 세션으로 교환한다. (REST — 설계 §7)
 *
 * code 는 서버가 GETDEL 로 즉시 소비하므로 정확히 1회만 호출해야 한다.
 */
export const exchangeSocialCode = async (code: string): Promise<AuthSession> => {
  const response = await fetch(`${env.VITE_API_URL}/api/auth/social/exchange`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ code }),
  });

  const body = (await response.json()) as ExchangeEnvelope;

  if (!response.ok || !body.success || !body.data) {
    throw new Error(body.error?.message ?? '소셜 로그인에 실패했습니다.');
  }

  return body.data;
};
